import { makeObservable } from 'mobx';

import { BaseForm } from '~/base/BaseForm';

export enum SignInFormFields {
  login = 'login',
  password = 'password',
}

export class SignInForm extends BaseForm {
  login: string = '';
  password: string = '';

  constructor(props?: unknown) {
    super(props);
    this.load(props);
  }

  static createObservable = () => {
    const context = new this();
    context.createObservable();

    return makeObservable(context, {
      ...context.makeObservableValues(SignInFormFields),
    });
  };
}
